/* Keep the server-rendered list aligned when native filters or Load more replace/add cards. */
(() => {
  const section = document.querySelector('.collection-wrapper')?.closest('.shopify-section');
  if (!section) return;
  function sync() {
    const schema = section.querySelector('[data-swd-collection-schema]');
    const grid = section.querySelector('#collection');
    if (!schema || !grid) return;
    try {
      const list = JSON.parse(schema.textContent);
      const items = [...grid.querySelectorAll('[data-swc-product]')].map(button => JSON.parse(button.dataset.swcProduct));
      const firstPosition = list.itemListElement?.[0]?.position || 1;
      list.itemListElement = items.map((item, index) => ({'@type':'ListItem',position:index + firstPosition,url:new URL(item.url, location.origin).href,name:item.title}));
      schema.textContent = JSON.stringify(list);
    } catch { /* Retain the valid server-rendered list if an unexpected card has malformed data. */ }
  }
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches('#collection, #collection > li') || node.querySelector('#collection'))) || (record.target.id === 'collection' && record.type === 'childList'))) sync();
  }).observe(section, {childList:true,subtree:true});
})();
